export default function waitForElement(getElement, observerElement = document.body, maxTime = 500) {
    return new Promise((resolve, reject) => {
        if (getElement()) {
            return resolve(getElement());
        }
        const observer = new MutationObserver((mutations) => {
            if (getElement()) {
                resolve(getElement());
                observer.disconnect();
            }
        });
        observer.observe(observerElement, {
            childList: true,
            subtree: true,
        });
        setTimeout(() => {
            observer.disconnect();
            reject();
        }, maxTime);
    });
}
